import type { TicketSla } from './api';

const SLA_MAP: Record<TicketSla['resolutionState'], { cls: string; label: string }> = {
  met: { cls: 'sla-met', label: 'SLA met' },
  on_track: { cls: 'sla-ok', label: 'On track' },
  at_risk: { cls: 'sla-risk', label: 'At risk' },
  breached: { cls: 'sla-breach', label: 'Breached' },
};

export default function SlaPill({ sla }: { sla?: TicketSla }) {
  if (!sla) return null;

  const item = SLA_MAP[sla.resolutionState] || SLA_MAP.on_track;
  let detail = '';
  if (sla.resolutionState === 'on_track' || sla.resolutionState === 'at_risk') {
    detail = ` - ${sla.hoursToResolutionDue}h left`;
  } else if (sla.resolutionState === 'breached' && sla.isActive) {
    detail = ` - ${Math.abs(sla.hoursToResolutionDue)}h over`;
  }

  return <span className={`ticket-pill ${item.cls}`}>{item.label}{detail}</span>;
}
